module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/design-tile-images/design-tile-03-e75aa3a92e57f15ba6cccf8b5555d4d5.jpg";